import { WorksFilters } from "../types/work-filters";

export const mapWorksFiltersToQuery = (filters: WorksFilters) => {
  return {
    customerIds: filters.customerIds.map((item) => item.value),
    workName: filters.workName.map((item) => item.label),
    userIds: filters.userIds.map((item) => item.value),
    workStatuses: filters.workStatuses.map((item) => item.label),
    worktypeIds: filters.worktypeIds.map((item) => item.value),
    startDates: filters.startDates,
    dueDates: filters.dueDates,
    fromDate: filters.fromDate,
    toDate: filters.toDate,
  };
};
